import React, { Fragment, useMemo } from "react";
import Model from "../../elements/CustomModel";
import { Modal } from "react-bootstrap";
import ModelBody from "../../elements/ModelBody";
import ModelFooter from "../../elements/ModelFooter";
import Form from "../../elements/CustomForm";
import Select from "../../elements/CustomSelect";
import Input from "../../elements/CustomInput";
import Button from "../../elements/CustomButton";
import Checkbox from "../../elements/CustomCheckBox";
import { Row } from 'react-bootstrap';
import { Table } from 'react-bootstrap';
const UpdateKits = ({
  isKitOpen,
  size,
  hideKitModel,
  otherProductStructure,
  laborCategories,
  mAddon,
  lAddon,
  kitLabor,
  kitMaterial,
  state,
  handleMaterialFilterChange,
  handleLaborFilterChange,
  handleLaborSelect,
  handleMaterialSelect,
  handleSubmit,
  materialAddOnFilter,
  laborAddOnFilter,
}) => {
  const filteredMAddon = useMemo(() => {
    if (!Array.isArray(mAddon)) return mAddon;
    return mAddon.filter(m => {
      if (materialAddOnFilter?.ProductTypeId && String(m.productStructureId) !== String(materialAddOnFilter.ProductTypeId)) return false;
      if (materialAddOnFilter?.PrivateName && !m.privateName?.toLowerCase().includes(materialAddOnFilter.PrivateName.toLowerCase())) return false;
      if (materialAddOnFilter?.Manufacturer && !m.manufacturer?.toLowerCase().includes(materialAddOnFilter.Manufacturer.toLowerCase())) return false;
      if (materialAddOnFilter?.Style && !m.style?.toLowerCase().includes(materialAddOnFilter.Style.toLowerCase())) return false;
      if (materialAddOnFilter?.Color && !m.color?.toLowerCase().includes(materialAddOnFilter.Color.toLowerCase())) return false;
      return true;
    });
  }, [mAddon, materialAddOnFilter]);

  const filteredLAddon = useMemo(() => {
    if (!Array.isArray(lAddon)) return lAddon;
    return lAddon.filter(l => {
      if (laborAddOnFilter?.ProductStructureIdForLabor && String(l.productStructureId) !== String(laborAddOnFilter.ProductStructureIdForLabor)) return false;
      if (laborAddOnFilter?.LaborCategory && String(l.laborCategoryId) !== String(laborAddOnFilter.LaborCategory)) return false;
      if (laborAddOnFilter?.LaborName && !l.laborName?.toLowerCase().includes(laborAddOnFilter.LaborName.toLowerCase())) return false;
      return true;
    });
  }, [lAddon, laborAddOnFilter]);

  return (
    <Fragment>
      <Model isOpen={isKitOpen} size={size}>
        <Modal.Header closeButton onClick={hideKitModel}>
          <Modal.Title>Edit Kit</Modal.Title>
        </Modal.Header>
        <Form handleSubmit={handleSubmit}>
          <ModelBody>
            <Row className="justify-content-center">
              <h4>Material Add Ons</h4>
              <div className="gridtable">
                <Table responsive bordered>
                  <thead>
                    <tr>
                      <th>Check to Add</th>
                      <th>
                        <Select label={`Product Structure`} handleChange={handleMaterialFilterChange} value={materialAddOnFilter?.ProductTypeId ?? ""} result={otherProductStructure} ids="ProductTypeId" validate={false} />
                      </th>
                      <th>
                        <Input label={`Private Name`} ids="PrivateName" validate={false} handleChange={handleMaterialFilterChange} />
                      </th>
                      <th>
                        <Input label={`Manufacturer`} ids="Manufacturer" validate={false} handleChange={handleMaterialFilterChange} />
                      </th>
                      <th>
                        <Input label={`Style`} ids="Style" validate={false} handleChange={handleMaterialFilterChange} />
                      </th>
                      <th>
                        <Input label={`Color`} ids="Color" validate={false} handleChange={handleMaterialFilterChange} />
                      </th>
                    </tr>
                  </thead>
                  <tbody>

                    {filteredMAddon && state.StoreId ? filteredMAddon.map((m, i) => (
                      <tr key={i}>
                        <td>
                          <Checkbox ids="Style" validate={false} value={kitMaterial.some(
                            d =>
                              d.ProductId ===
                              m.productId
                          )} handleChange={e =>
                            handleMaterialSelect(
                              e,
                              m.productId
                            )
                          } />
                        </td>
                        <td>{m.productStructure}</td>
                        <td>{m.privateName}</td>
                        <td>{m.manufacturer}</td>
                        <td>{m.style}</td>
                        <td>{m.color}</td>
                      </tr>
                    )) : (
                      <tr>
                        <td colSpan={`6`}>No Data Found</td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </Row>

            <Row className="justify-content-center">
              <h4>Labor Add Ons</h4>
              <div className="gridtable">
                <Table bordered>
                  <thead>
                    <tr>
                      <th>Check to Add</th>
                      <th>
                        <Select label={`Product Structure`} handleChange={handleLaborFilterChange} value={laborAddOnFilter?.ProductStructureIdForLabor ?? ""} result={otherProductStructure} ids="ProductStructureIdForLabor" validate={false} />
                      </th>
                      <th>
                        <Select label={`Labor Category`} result={laborCategories} ids="LaborCategory" validate={false} handleChange={handleLaborFilterChange} />
                      </th>
                      <th>
                        <Input label={`Labor Name`} ids="LaborName" validate={false} handleChange={handleLaborFilterChange} />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredLAddon && state.StoreId ? filteredLAddon.map((l, i) => (
                      <tr key={i}>
                        <td>
                          <Checkbox ids="Style" validate={false} value={kitLabor.some(
                            d =>
                              d.LaborItemId ===
                              l.laborItemId
                          )} handleChange={e =>
                            handleLaborSelect(
                              e,
                              l.laborItemId
                            )
                          } />
                        </td>
                        <td>{l.productStructure}</td>
                        <td>{l.laborCategory}</td>
                        <td>{l.laborName}</td>
                      </tr>
                    )) : (
                      <tr>
                        <td colSpan={`6`}>No Data Found</td>
                      </tr>
                    )}

                  </tbody>
                </Table>
              </div>
            </Row>

          </ModelBody>
          <ModelFooter>
            <Button variant="secondary" type="button" handleClick={hideKitModel}>
              Close
            </Button>
            <Button variant="primary" type="submit">
              Save
            </Button>
          </ModelFooter>
        </Form>
      </Model>
    </Fragment>
  )

}

export default UpdateKits;